"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.promise.js");
require("core-js/modules/es.object.assign.js");
var _vue = _interopRequireDefault(require("vue"));
var _Dialog = _interopRequireDefault(require("./Dialog"));
var _utils = require("../utils");
var instance;
function initInstance() {
  if (instance) {
    instance.$destroy();
  }
  instance = new (_vue.default.extend(_Dialog.default))({
    el: document.createElement('div'),
    // avoid missing animation when first rendered
    propsData: {
      lazyRender: false
    }
  });
  instance.$on('input', function (value) {
    instance.value = value;
  });
}
function Dialog(options) {
  if (_utils.isServer) {
    return Promise.resolve();
  }
  return new Promise(function (resolve, reject) {
    if (!instance || !(0, _utils.isInDocument)(instance.$el)) {
      initInstance();
    }
    Object.assign(instance, Dialog.currentOptions, options, {
      resolve: resolve,
      reject: reject
    });
  });
}
Dialog.defaultOptions = {
  value: true,
  title: '',
  message: '',
  business: false,
  wider: false,
  transparent: false,
  overlay: true,
  className: '',
  lockScroll: true,
  beforeClose: null,
  promptMode: false,
  promptType: 'text',
  promptDefaultText: '',
  promptPlaceholder: '',
  messageAlign: '',
  getContainer: 'body',
  lineFeed: false,
  confirmButtonText: '',
  cancelButtonText: '',
  showConfirmButton: true,
  showCancelButton: false,
  closeOnClickOverlay: false,
  fade: false,
  showClose: false,
  showTopClose: false,
  callback: function callback(action, param) {
    var type = action === 'confirm' ? 'resolve' : 'reject';
    var res = action === 'confirm' ? param : action;
    instance[type](res);
  }
};
Dialog.alert = Dialog;
Dialog.confirm = function (options) {
  return Dialog(Object.assign({
    showCancelButton: true
  }, options));
};
Dialog.prompt = function (options) {
  return Dialog(Object.assign({
    promptMode: true,
    showCancelButton: true
  }, options));
};
Dialog.close = function () {
  if (instance) {
    instance.value = false;
  }
};
Dialog.setDefaultOptions = function (options) {
  Object.assign(Dialog.currentOptions, options);
};
Dialog.resetDefaultOptions = function () {
  Dialog.currentOptions = Object.assign({}, Dialog.defaultOptions);
};
Dialog.resetDefaultOptions();
Dialog.install = function () {
  _vue.default.use(_Dialog.default);
};
_vue.default.prototype.$dialog = Dialog;
var _default = Dialog;
exports.default = _default;